<template>
  <div class="operation_center">
    <!-- 操作按钮容器 -->
    <div class="operation_button_box" :style="{ justifyContent: align }">
      <!-- 显示的主要按钮列表 -->
      <div class="operation_button_list" :class="[className, !isShowMoreBtn ? 'operation_Button_style' : '']">
        <template v-for="(item, index) in visibleButtons">
          <!-- 普通按钮 -->
          <div v-if="!item.customRender && item.show"
            :key="index"
            class="operation_button_item"
            :style="getButtonStyle(item)"
            @click="item.clickFn">
            {{ item.text }}
          </div>
          <!-- 自定义渲染内容按钮 -->
          <RenderDom v-else-if="item.customRender && item.show" :renderCustomContent="item.renderCustomContent" :paramsData="item.paramsData"/>
        </template>
      </div>
      <!-- 下拉更多按钮 -->
      <Dropdown transfer v-if="dropdownButtons.length > 0 && isShowMoreBtn">
        <a href="javascript:void(0)" :style="{ color: buttonColor }">
          <span>{{ $t('key1000106') }}</span>
          <Icon type="ios-arrow-down"/>
        </a>
        <template #list>
          <DropdownMenu>
            <template v-for="(item, index) in dropdownButtons">
              <DropdownItem :key="index" v-if="!item.customRender" @click.native="item.clickFn">{{ item.text }}</DropdownItem>
              <RenderDom v-else :renderCustomContent="item.renderCustomContent" :paramsData="item.paramsData"/>
            </template>
          </DropdownMenu>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import RenderDom from '@/utils/renderCustomContent';
import {isAlibabaDistributor} from "@/utils/common";

export default {
  name: 'operationButtons',

  props: {
    /** 对齐方式，默认左对齐，可选 'flex-start', 'center', 'flex-end' */
    align: {
      type: String,
      default: 'flex-start'
    },
    /** 操作按钮数组
     * item 结构示例：
     * {
     *   text: '按钮文字',
     *   show: true/false, // 是否显示按钮
     *   color: '#ff0000', // 可选，自定义颜色
     *   styles: {},       // 可选，自定义样式对象
     *   clickFn: () => {}, // 点击方法
     *   customRender: true/false, // 是否自定义渲染
     *   renderCustomContent: (h) => {}, // 自定义渲染函数
     *   paramsData: {} // 自定义 render 传入的参数
     * }
     */
    operationList: {
      type: Array,
      default: () => []
    },
    /** 按钮外层 className */
    className: {type: String, default: ''},
    /** 是否展示更多按钮，默认 true 超过两个按钮显示“更多” */
    isShowMoreBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /** 前台显示的按钮列表，最多显示 2 个 */
    visibleButtons() {
      const list = this.operationList.filter(item => item.show);
      if (!this.isShowMoreBtn || list.length <= 3) return list;
      return list.slice(0, 2);
    },

    /** 下拉菜单显示的按钮 */
    dropdownButtons() {
      const list = this.operationList.filter(item => item.show);
      if (!this.isShowMoreBtn || list.length <= 3) return [];
      return list.slice(2);
    },

    /** 按钮默认颜色，根据页面路径和阿里巴巴分销商情况返回 */
    buttonColor() {
      const pathname = window.location.pathname;
      let color = '';
      const map = [
        {path: '/yms.html', color: '#2d8cf0'},
        {path: '/supplier.html', color: '#2d8cf0'},
        {path: '/distributor.html', color: '#FD5425'},
      ];
      map.forEach(m => {
        if (pathname.includes(m.path)) color = isAlibabaDistributor() ? '#2d8cf0' : m.color;
      });
      return color;
    }
  },

  methods: {
    /** 获取单个按钮样式
     * @param {Object} item 操作按钮对象
     * @returns {Object} 样式对象
     */
    getButtonStyle(item) {
      return {
        color: item.color || this.buttonColor,
        ...item.styles
      };
    }
  },
  components: {
    RenderDom
  }
};
</script>

<style scoped>
.operation_center {
  width: 100%;
  text-align: left;
}

.operation_button_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.operation_button_list,
.operation_Button_style {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.operation_Button_style {
  flex-direction: column;
  align-items: flex-start;
}

.operation_button_item {
  padding: 0px 7px;
  background-color: transparent;
  cursor: pointer;
}

.operation_button_item:hover {
  text-decoration: underline;
}

.ivu-dropdown a {
  padding: 2px 6px;
}

.ivu-dropdown a:hover {
  text-decoration: initial;
}
</style>
